import React, { useEffect, useState, useContext } from "react";
import Module from "../../../../templates/components/Module";
import moment from "moment";
import { store } from "../../../../../context/StateProvider";
import Table2 from "../../../../templates/components/Table2";
import HPTDatePicker from "../../../../templates/components/HPTDatePicker";
import DimLoader from '../../../../templates/components/DimLoader';
import Utilities from "../../../../../services/commonservice/utilities";
import PatientService from "../../../../../services/api/patient.service";
import StorageService from "../../../../../services/session/storage.service";
import AppointmentService from "../../../../../services/api/appointment.service";

const TranscriptsTable = (props) => {
    const [transcripts, setTranscripts] = useState();
    const [isLoader, setIsLoader] = useState(false);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const state = useContext(store).state
    const [initialMessage, setInitialMessage] = useState(true)
    const [locationList, setLocationList] = useState(state.practiceLocations || null)
    const [locationId, setLocationId] = useState(state.practiceLocationId || null)
    const [isLocationClearable, setIsLocationClearable] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? false : true)

    useEffect(() => {
        if (!locationList) {
            if (StorageService.get("session", "locale")) {
                let payload = JSON.parse(StorageService.get("session", "locale"))
                setLocationList(payload)
            }
            else {
                findLocations();
            }
        }
    }, [])
    const findLocations = () => {
        AppointmentService.practiceLocationLookup()
            .then((res) => {
                setLocationList(res)
                setLocationId(res[0].practiceLocationId)
            })
            .catch((err) => {
                console.log(err);
            });
    }
    const transcriptsLookup = (newLocationId) => {
        const params = {
            StartDate: startDate ? moment(startDate).toISOString() : null,
            EndDate: endDate ? moment(endDate).toISOString() : null,
            SortField: 'CreatedOn',
            Asc: false,
        };
        if (locationId) {
            params.PracticeLocationId = newLocationId || locationId
        }
        setInitialMessage(false);
        setIsLoader(true);

        PatientService.findTranscripts(params)
            .then((res) => {
                if (res?.data?.data?.length > 0) {
                    setTranscripts(res.data.data);
                } else {
                    setTranscripts([]);
                }
                setIsLoader(false);
            })
            .catch((error) => {
                setTranscripts([]);
                setIsLoader(false);
            });
    };

    const columns = [
        {
            Header: "Patient Name",
            id: "patientName",
            accessor: (row) => row.patientName || "",
        },
        {
            Header: "Status",
            id: "medicalScribeJobStatus",
            accessor: (row) => row.medicalScribeJobStatus
        },
        {
            Header: "Submitted On",
            id: "dateSubmitted",
            accessor: (row) => row.dateSubmitted ? moment(row.dateSubmitted).format("MM-DD-YYYY h:mm A") : "",
        },
        {
            Header: "Completed On",
            id: "dateCompleted",
            accessor: (row) => row.dateCompleted ? moment(row.dateCompleted).format("MM-DD-YYYY h:mm A") : "",
        },
    ];

    return (
        <>
            {isLoader &&
                <DimLoader loadMessage="Processing" />
            }

            <div className="row d-flex g-3">
                <div className="col-12 m-p-0">
                    <Module title="Filters">
                        <div className='row d-flex'>
                            <div className='col-12 row d-flex justify-content-center mx-0 align-items-end report-filters'>
                                <HPTDatePicker practicePlaceHolder={'All'} timePeriod={"all"} includeAll locationClearable={isLocationClearable} setLocationId={setLocationId} startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} />
                                <div className="col-md-auto col-12">
                                    <button className="btn btn-primary" onClick={e => { e.preventDefault(); transcriptsLookup() }} title="Pull Report">
                                        <i className="icon arrow circle right" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Module>
                </div>
                <div className="col-12 m-p-0">
                    <Module title="Transcripts Report">
                        <Table2 export searchable title="Transcripts Report" data={transcripts} loading={isLoader} columns={columns} initialMessage={initialMessage} />
                    </Module>
                </div>
            </div>
        </>
    );
};

export default TranscriptsTable;